import * as React from 'react';
import { compose, setDisplayName, withState, withHandlers, lifecycle, onlyUpdateForKeys } from 'recompose';
import { skin } from 'ui/styles/skin';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { modal } from 'ui/shared/modal';
import { Button } from 'ui/shared/Button';
import { Input } from 'ui/shared/Input';

export type OwnProps = {
    visible: boolean;
    name: string | null;
    onAccept: (name: string) => void;
    onCancel: () => void;
};

const styles = {
    fieldWrapper: {
        margin: '1em 0 2em 0',
    },
    label: {
        marginRight: '.5em',
    },
    buttonBar: {
        marginTop: '1em',
        textAlign: 'right',
    } as React.CSSProperties,
};

const autoSelect = (e: React.FocusEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    input.setSelectionRange(0, input.value.length);
};

export const RawRenameZoneDialog = ({ value, handleKeyDown, handleChange, handleSubmit, onCancel, t, ...props }: OwnProps & RecomposeProps & TranslateProps) =>
    <form
        onSubmit={ handleSubmit }
        onKeyDownCapture={ handleKeyDown }
    >
        <div style={ styles.fieldWrapper }>
            <label style={ styles.label }>
                { t('WC_REPORT_HEAT_MAP_ZONE_NAME') }
            </label>
            <Input
                id="rename-zone"
                value={ value }
                onChange={ handleChange }
                autoFocus={ true }
                onFocus={ autoSelect }
            />
        </div>
        <div style={ styles.buttonBar }>
            <Button
                id="rename-zone-ok-button"
                type="submit"
                textKey="1"
                disabled={ !value }
            />
            <Button
                id="rename-zone-cancel-button"
                type="button"
                onClick={ onCancel }
                textKey="290"
            />
        </div>
    </form>
;

type RecomposeProps = {
    value: string;
    handleSubmit: () => void;
    handleKeyDown: React.KeyboardEventHandler<HTMLFormElement>;
    handleChange: React.ChangeEventHandler<HTMLInputElement>;
};
type _RecomposeProps = RecomposeProps & {
    _setValue: (name: string) => void;
};


export const RenameZoneDialog = compose<OwnProps & RecomposeProps & TranslateProps, OwnProps>(
    setDisplayName('RenameZoneDialog'),
    skin,
    translate(),
    withState('value', '_setValue', ({ name }: OwnProps) => name || ''),
    withHandlers({
        handleSubmit: ({ onAccept, value }: OwnProps & RecomposeProps) => (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            onAccept(value);
            return false;
        },
        handleKeyDown: ({ onCancel }: OwnProps) => (e: React.KeyboardEvent<HTMLFormElement>) => {
            if (e.key === 'Escape') {
                onCancel();
            }
        },
        handleChange: ({ _setValue }: OwnProps & _RecomposeProps) => (e: React.ChangeEvent<HTMLInputElement>) => {
            _setValue(e.target.value);
        },
    }),
    lifecycle<OwnProps & _RecomposeProps, {}>({
        componentWillReceiveProps(newProps) {
            // Reset the text field when the dialog is shown
            // (don't reset it when hiding because we don't want it to change while the dialog is fading out)
            if (!this.props.visible && newProps.visible) {
                const { name } = newProps;
                newProps._setValue(name || '');
            }
        },
    }),
    onlyUpdateForKeys([ 'value', 'visible' ]),
    modal('rename-zone-dialog'),
)(RawRenameZoneDialog);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/zoneSelection/RenameZoneDialog.tsx